import { render, staticRenderFns } from "./HandleCalData.vue?vue&type=template&id=b1f04434&scoped=true"
import script from "./HandleCalData.vue?vue&type=script&lang=js"
export * from "./HandleCalData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f04434",
  null
  
)

export default component.exports